import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Grid} from 'semantic-ui-react';
import {DropdownField, InputField} from '../../../../common/components/form';
import {Field, formValueSelector} from 'redux-form';
import {MASTER_VEHICLE_FORM} from '../../../../common/forms';
import {getOptions} from './helper';
import './editProductData.scss';

class ImportData extends Component {
  render() {
    const {addImport, jdeList, description} = this.props;
    return (
      <div>
        <Card raised fluid className='vehicle-master-form'>
          <Grid textAlign='left'>
            <Grid.Row>
              <Grid.Column width={2}>
                <h4>Descripción Sri</h4>
              </Grid.Column>
              <Grid.Column width={10}>
                <h4>{description} </h4>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>
                <h4>Partida Arancelaria</h4>
              </Grid.Column>
              <Grid.Column width={3}>
                <Field
                  name='tariffHeading'
                  options={getOptions(jdeList.arancelList, 'completeName')}
                  component={DropdownField}
                  placeholder='Seleccione una opción'
                  disabled={!addImport}
                  required
                />
              </Grid.Column>
              <Grid.Column width={2}>
                <h4>Inen</h4>
              </Grid.Column>
              <Grid.Column width={3}>
                <Field
                  name='inen'
                  options={getOptions(jdeList.inenList, 'name')}
                  component={DropdownField}
                  placeholder='Seleccione una opción'
                  disabled={!addImport}
                  required
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>
                <h4>Peso Bruto (Kg)</h4>
              </Grid.Column>
              <Grid.Column width={3}>
                <Field
                  name='wholeWeight'
                  component={InputField}
                  type='Number'
                  min="0.000" step="0.001" pattern='^\d+(?:\.\d{1,2})?$'
                  disabled={!addImport}
                  invalidMessage=
                    'Por favor, llene este campo siguiendo el formato 0.000 y el valor mínimo debe ser 0.01'
                  required
                />
              </Grid.Column>
              <Grid.Column width={2}>
                <h4>Volumen (m3)</h4>
              </Grid.Column>
              <Grid.Column width={3}>
                <Field
                  name='volume'
                  component={InputField}
                  type='Number'
                  min="0.000" step="0.001" pattern='^\d+(?:\.\d{1,2})?$'
                  disabled={!addImport}
                  invalidMessage='Por favor, llene este campo siguiendo el formato 0.000'
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const formValues = formValueSelector(MASTER_VEHICLE_FORM.name);
  const description = formValues(state, 'description');
  const wholeWeight = formValues(state, 'wholeWeight');
  return {
    'jdeList': state.masterVehicle.jdeList,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
    wholeWeight,
    description,
  };
};

export default connect(mapStateToProps)(ImportData);
